// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table .warning-row{background:#fdf5e6}.el-table .success-row{background:#f0f9eb}", ""]);
// Exports
module.exports = exports;
